import React from "react";
import { ShieldCheck, Building2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { PRIVACY } from "../data/privacy";
import { COMPANY } from "../data/terms";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { ScrollArea } from "./ui/scroll-area";

const renderBlock = (block, bi) => {
  if (block.type === "sub") {
    return (
      <h4 key={bi} className="font-semibold text-teal-800 text-sm mt-1">
        {block.text}
      </h4>
    );
  }
  if (block.type === "ul") {
    return (
      <ul key={bi} className="space-y-1.5">
        {block.items.map((it, ii) => (
          <li
            key={ii}
            className="flex items-start gap-2 text-sm leading-relaxed text-slate-700"
          >
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-teal-500 shrink-0" />
            {it}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <p key={bi} className="text-sm leading-relaxed text-slate-700">
      {block.text}
    </p>
  );
};

const PrivacyModal = () => {
  const { t } = useLanguage();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-white/70 hover:text-cyan-300 text-sm transition-colors text-left">
          {t("privacyLink")}
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-2xl max-h-[85vh] p-0 gap-0 overflow-hidden">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-teal-100">
          <DialogTitle className="flex items-center gap-2.5 font-display text-xl text-[#0d3b43]">
            <span className="w-9 h-9 rounded-xl bg-teal-600 text-white flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" />
            </span>
            Política de Privacidad
          </DialogTitle>
          <DialogDescription className="text-slate-500 pt-1">
            {PRIVACY.updated}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[64vh] px-6 py-5">
          <div className="pr-2">
            <div className="rounded-xl border border-teal-200 bg-teal-50 p-4 mb-6">
              <div className="flex items-center gap-2 text-teal-800 font-bold mb-2">
                <Building2 className="w-4 h-4" />
                {COMPANY.tradeName}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">
                Nombre comercial de{" "}
                <strong className="text-[#0d3b43]">{COMPANY.legalName}</strong>.
              </p>
              <p className="text-sm text-slate-600 mt-1">{COMPANY.addressInline}</p>
              <p className="text-sm text-slate-600">
                {COMPANY.email} · {COMPANY.phone} · {COMPANY.website}
              </p>
            </div>

            <div className="space-y-2.5 mb-6">
              {PRIVACY.intro.map((p, i) => (
                <p key={i} className="text-sm leading-relaxed text-slate-700">
                  {p}
                </p>
              ))}
            </div>

            <div className="space-y-7">
              {PRIVACY.sections.map((sec, i) => (
                <section key={i}>
                  <h3 className="flex items-start gap-2.5 font-display font-bold text-[15px] text-[#0d3b43] mb-3">
                    <span className="shrink-0 w-6 h-6 rounded-md bg-teal-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
                      {i + 1}
                    </span>
                    {sec.title}
                  </h3>
                  <div className="space-y-2.5 pl-8">
                    {sec.content.map((block, bi) => renderBlock(block, bi))}
                  </div>
                </section>
              ))}
            </div>

            <p className="mt-8 pt-5 border-t border-teal-100 text-xs text-slate-500 text-center">
              {PRIVACY.copyright}
            </p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyModal;
